import { combineReducers } from "redux";

import authReducer from "./authReducer";
import userReducer from "./userReducer";
import memberReducer from "./memberReducer";
import organisationReducer from "./organisationReducer";
import surveyReducer from "./surveyReducer";
import usersReducer from "./usersReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  member: memberReducer,
  organisation: organisationReducer,
  survey: surveyReducer,
  users: usersReducer,
});

export default rootReducer;
